import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import {
  EncounterSummaryViewModel,
} from 'dtos';
import Tag from 'core/components/Tag';
import {
  formatDate,
} from 'utils/date';

type Props = {
  visit: Pick<
    EncounterSummaryViewModel,
    'encounterId' | 'typeOfVisitDescription' | 'startDateTime'
  >;
};

export default function RTMVisitLabel({ visit }: Props) {
  return visit.encounterId === 0 ? (
    <div className="w-full flex items-center gap-2">
      <AddIcon className="!w-4 !h-4 !text-gray-500" />
      <strong className="font-semibold">New Encounter</strong>
    </div>
  ) : (
    <div className="w-full flex items-center gap-2">
      <Tag
        className="max-w-[250px] truncate"
        tagName={visit.typeOfVisitDescription ?? ''}
      />
      <p className="font-semibold">{formatDate(visit.startDateTime ?? '')}</p>
    </div>
  );
}
